module.exports = __webpack_public_path__ + "static/media/guide-line-06.ac1dd96f.svg";